import {
  PageResponse,
  Response,
  PageData,
  IntegrationLogSearchParams,
  IntegrationLogVo,
} from "@/types";
import { APIRequest } from "@/utils/api";

const IntegrationEventsAPI = new APIRequest({
  baseURL: "/api/wms/v2/integration/events",
});

export async function queryEvents(
  params: IntegrationLogSearchParams,
): Promise<PageData<IntegrationLogVo>> {
  return IntegrationEventsAPI.get<PageResponse<IntegrationLogVo>>({
    url: "",
    params,
  }).then((res) => res.data);
}

export async function getEventDetail(logId: number): Promise<IntegrationLogVo> {
  return IntegrationEventsAPI.get<Response<IntegrationLogVo>>({
    url: `/${logId}`,
  }).then((res) => res.data);
}
